import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Input from "../common/Input";
import Button from "../common/Button";
import {
  ChangePasswordFormData,
  changePasswordSchema,
} from "../../schemas/profileSchema";
import { FieldError } from "react-hook-form";

interface ChangePasswordFormProps {
  onSubmit: (data: ChangePasswordFormData) => void;
  onCancel?: () => void;
  isLoading?: boolean;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  onSubmit,
  onCancel,
  isLoading = false,
}) => {
  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
    trigger,
  } = useForm<ChangePasswordFormData>({
    resolver: zodResolver(changePasswordSchema),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  const handleFormSubmit = (data: ChangePasswordFormData) => {
    onSubmit(data);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
      <Input
        label="Current Password"
        placeholder="Enter current password"
        name="currentPassword"
        type="password"
        value={watch("currentPassword") || ""}
        onChange={(e) => setValue("currentPassword", e.target.value, { shouldValidate: false })}
        onBlur={() => trigger("currentPassword")}
        error={errors.currentPassword as FieldError | undefined}
      />
      <Input
        label="New Password"
        placeholder="Enter new password"
        name="newPassword"
        type="password"
        value={watch("newPassword") || ""}
        onChange={(e) => setValue("newPassword", e.target.value, { shouldValidate: false })}
        onBlur={() => trigger("newPassword")}
        error={errors.newPassword as FieldError | undefined}
      />
      <Input
        label="Confirm New Password"
        placeholder="Confirm new password"
        name="confirmPassword"
        type="password"
        value={watch("confirmPassword") || ""}
        onChange={(e) => setValue("confirmPassword", e.target.value, { shouldValidate: false })}
        onBlur={() => trigger("confirmPassword")}
        error={errors.confirmPassword as FieldError | undefined}
      />
      <div className="flex justify-end space-x-4">
        {onCancel && (
          <Button
            type="button"
            variant="secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </Button>
        )}
        <Button
          type="submit"
          variant="primary"
          isLoading={isLoading}
          className="w-full sm:w-auto"
        >
          Change Password
        </Button>
      </div>
    </form>
  );
};

export default ChangePasswordForm;

